import { getUserType } from "../store/common/selectors";
import { store } from "../store/store";
export var getAccountType = function getAccountType() {
  var state = store.getState();
  var userType = getUserType(state);
  return userType === 0 ? 'mobile' : 'fttb';
};